export enum InformationUpdateFrequencyType {
  OnceAYear = 'OnceAYear', // раз в год
  Semiannually = 'Semiannually', // раз в полгода
  OnceAMonth = 'OnceAMonth', // раз в месяц
}
